export * from './lib/CopyLottery';
